module.exports = __webpack_public_path__ + "static/media/mindfulness.72922fc8.png";